import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SocialWidget from '../Widget/SocialWidget';
import './header.scss';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Div from '../Div';
import DropDown from './DropDown';
import LanguageSwitcher from '../LanguageSwitcher';
import { getServicesData } from '../../data/servicesData';
import { localizePath } from '../../helper/localizedPath';

export default function Header({ variant }) {
  const { t, i18n } = useTranslation();
  const servicesData = getServicesData(i18n.language === 'en' ? 'en' : 'cs');
  const language = i18n.language === 'en' ? 'en' : 'cs';

  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ''
        } cs-sticky_header ${isSticky ? 'cs-sticky_header_active' : ''}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Link className="cs-site_branding" to={localizePath('/', language)}>
                  <img src="/images/stablerecords/SR-white-logo.webp" alt="Logo" />
                </Link>
              </Div>
              <Div className="cs-main_header_center">
                <Div className="cs-nav cs-primary_font cs-medium">
                  <ul
                    className="cs-nav_list"
                    style={{ display: `${mobileToggle ? 'block' : 'none'}` }}
                  >
                    <li>
                      <NavLink to={localizePath('/', language)} onClick={() => setMobileToggle(false)}>
                        {t('nav.home')}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={localizePath('/ostudiu', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.about')}
                      </NavLink>
                    </li>
                    <li className="menu-item-has-children">
                      <NavLink
                        to={localizePath('/sluzby', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.services')}
                      </NavLink>
                      <DropDown>
                        <ul>
                          <li>
                            <Link
                              to={localizePath('/cenik', language)}
                              onClick={() => setMobileToggle(false)}
                            >
                              {t('nav.servicesAndPrices')}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={localizePath('/vybaveni', language)}
                              onClick={() => setMobileToggle(false)}
                            >
                              {t('nav.equipment')}
                            </Link>
                          </li>
                          {servicesData.map((item, index) => (
                            <li key={index}>
                              <Link
                                to={localizePath(`/sluzby/${item.id}`, language)}
                                onClick={() => setMobileToggle(false)}
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </DropDown>
                    </li>
                    <li>
                      <NavLink
                        to={localizePath('/portfolio', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.portfolio')}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={localizePath('/kalendar', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.calendar')}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={localizePath('/kontakt', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.contact')}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={localizePath('/faq', language)}
                        onClick={() => setMobileToggle(false)}
                      >
                        {t('nav.faq')}
                      </NavLink>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs-munu_toggle cs-toggle_active'
                        : 'cs-munu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </Div>
              </Div>
              <Div className="cs-main_header_right">
                <LanguageSwitcher />
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <Div
        className={
          sideHeaderToggle ? 'cs-side_header active' : 'cs-side_header'
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to={localizePath('/', language)}>
            <img src="/images/stablerecords/SR-white-logo.webp" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading" dangerouslySetInnerHTML={{ __html: t('header.projectIdea') }} />
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title={t('header.contactUs')} withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <SocialWidget />
          </Div>
        </Div>
      </Div>
    </>
  );
}